import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { WorkflowInboxService } from '../camtl.service';
import { BaseService } from '../../mesc/mesc.service';
import { CgpGridComponent } from '../../../shared/cgp-grid/cgp-grid.component';
import { cgpAuthentication } from '../../../../modules/cgp-authentication';
import { Subject } from 'rxjs';
import { AuthenticationService } from '../../../../app/auth.service'

@Component({
  selector: 'app-workflowinbox-tools',
  templateUrl: './workflow-inbox.component.html',
  // styleUrls: ['./legacy-tools.component.scss']
})
export class WorkflowInboxComponent implements OnInit, OnDestroy {

  constructor(
    public service: WorkflowInboxService,
    public baseService: BaseService,
    public authService: AuthenticationService) {
    this.email = cgpAuthentication.getUserInfo().mail;

  }

  private ngUnsubscribe: Subject<void> = new Subject<void>();
  public email: string;
  public isAdmin: boolean = false;

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  @ViewChild(CgpGridComponent, { static: true }) grid: CgpGridComponent;

  columns: any[] = [{
    field: 'SystemNumber',
    title: 'System',
    width: 100
  },
  {
    field: 'ProgramCode',
    title: 'Program',
  },
  {
    field: 'Suffix',
    title: 'Description',
  },
  {
    field: 'StepName',
    title: 'Process Location',
  }];

  onRead = (): Promise<any> => {
    var self = this;
    return this.baseService.read("group/MESC_CAMTL_SuperUsers/user", true).then(function (response) {
      self.isAdmin = self.authService.isClaimValid("/MESC/CAMTL/Administration");
      return self.service.read("/" + self.email + "/" + self.isAdmin, true).then(function (response) {
        return response;
      });
    })

  }

  viewAllocationPage = (e, dataItem) => {
    window.location.href = '#/MESC/CAMTL/Approval/' + dataItem.SystemId;
  }

  customButtons = [
    {
      id: 'viewAllocation',
      class: 'fa fa-window-restore',
      title: 'View Allocation Page',
      callback: this.viewAllocationPage
    }
  ]

  template = {
    controls: {
      add: false,
      edit: false,
      delete: false,
      excel: true,
      custom: this.customButtons,
      width: 65
    },
    read: this.onRead,
    columns: this.columns,
    service: this.service,
    fileName: 'workflow.xlsx'
  };

  ngOnInit() {
    var self = this;
  }
}
